module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[27]148.3f5dbba.woff2";